import { useCallback, useMemo, useState } from 'react';
import { addTitleRowsIntoStudents, groupStudentsBySkillsLevel, mapGroupSkills, } from './utils';
import { sortByRating } from '../../tableConfig';
var useStudentsSkillsTableData = function (_a) {
    var groupSkills = _a.groupSkills, groupGradeValue = _a.groupGradeValue;
    var _b = useMemo(function () {
        if (!groupSkills)
            return { students: [], grades: [] };
        return mapGroupSkills(groupSkills, groupGradeValue);
    }, [groupSkills, groupGradeValue]), students = _b.students, grades = _b.grades;
    var groupedStudents = useMemo(function () { return groupStudentsBySkillsLevel(students); }, [students]);
    var _c = useState(), sortingRule = _c[0], setSortingRule = _c[1];
    var tableData = useMemo(function () {
        if (sortingRule) {
            return students.slice().sort(function (a, b) {
                return sortByRating(a, b, sortingRule.id, sortingRule.desc);
            });
        }
        return addTitleRowsIntoStudents(groupedStudents);
    }, [sortingRule, groupedStudents, students]);
    var handleSortChange = useCallback(function (sortings) {
        setSortingRule(sortings[0]);
    }, []);
    return {
        tableData: tableData,
        students: students,
        groupedStudents: groupedStudents,
        grades: grades,
        handleSortChange: handleSortChange,
    };
};
export { useStudentsSkillsTableData };
